import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'inloggen',
    loadComponent: () => import('./containers/sign-in/sign-in.component').then(m => m.SignInComponent),
  },
  {
    path: 'registreren',
    loadComponent: () => import('./containers/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'wachtwoord-vergeten',
    loadComponent: () => import('./containers/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'bevestig-account',
    loadComponent: () => import('./containers/activate-account/activate-account.component').then(m => m.ActivateAccountComponent),
  },
  {
    path: 'reset',
    loadComponent: () => import('./containers/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
];
